import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'

export function dateFormatWithHours(inputDate: Date | string): string {
  const date = dayjs(inputDate, { format: 'YYYY-MM-DD HH:mm' })
  const formattedDate = date.format('DD MMM YYYY - HH:mm')
  return formattedDate
}
